import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import InputTextArea from '../../components/inputs/InputTextArea';
import { Form } from 'informed';

class ItemActionInativeModal extends React.Component {
  render() {
    const { isOpen, toggle, title, action, justificativa } = this.props;

    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <Form>
          <ModalHeader toggle={toggle}>{title}</ModalHeader>
          <ModalBody>
            <React.Fragment>
              <InputTextArea
                label="Justificativa"
                col="col-md-12"
                field="justificativa_anulacao"
                onChange={(e) => justificativa(e.target.value)}
              />
            </React.Fragment>
          </ModalBody>
          <ModalFooter>
            <button className="btn primary-button" onClick={action}>
              OK
            </button>
          </ModalFooter>
        </Form>
      </Modal>
    );
  }
}

ItemActionInativeModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  validTitle: PropTypes.string,
  invalidTitle: PropTypes.string,
  valid: PropTypes.arrayOf(PropTypes.number),
  invalid: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.number,
      errors: PropTypes.arrayOf(PropTypes.string)
    })
  )
};

ItemActionInativeModal.defaultProps = {
  isOpen: false,
  title: '',
  validTitle: '',
  invalidTitle: '',
  valid: [],
  invalid: []
};

export default ItemActionInativeModal;
